module.exports = __webpack_public_path__ + "img/f051e40.jpg";